import React from "react";
import {Form, Select, Switch} from "antd";
import TranslationInput from "../../../../shared/input/TranslationInput";
import Utils from "../../../../../utils";
import IContentType from "../../../../../model/interface/dataStorage/IContentType";
import LocaleText from "../../../settings/dictionary/LocaleText";
import FieldPicker from "../../../../shared/pickers/FieldPicker";
import IPopupOptions from "../../../../../model/interface/widget/option/IPopupOptions";
import ButtonProperties from "./ButtonProperties";
import Collapse from "../../../../shared/display/collapse/Collapse";

interface IProps {
    options: IPopupOptions,
    contentType?: IContentType
}

class PopupWidgetEditor extends React.Component<IProps> {

    render() {
        const {contentType, options} = this.props
        return (
            <div>
                <Form.Item name={'title'} label={<LocaleText code={'general.title'}/>  }>
                    <TranslationInput code={'configuration.widget.popup.' + Utils.uuid()} preserveCode={true}/>
                </Form.Item>
                <Form.Item name={'trigger'}
                           label={<LocaleText code={'configuration.widget.popup.trigger'} fallback={'Spouštěč'}/>}
                           rules={[{required: true}]}>
                    <Select>
                        {[
                            {value: 'auto', label: 'configuration.widget.popup.trigger.auto', labelFallback: 'Ihned'},
                            {
                                value: 'button',
                                label: 'configuration.widget.popup.trigger.button',
                                labelFallback: 'Tlačítko'
                            },
                            {
                                value: 'action',
                                label: 'configuration.widget.popup.trigger.action',
                                labelFallback: 'Akce (zatim nefunguje)'
                            },
                            {
                                value: 'alertChangeField',
                                label: 'configuration.widget.popup.alert-change-field.',
                                labelFallback: 'Změna pole záznamu'
                            }
                        ]
                            .filter(trigger => (contentType || !['alertChangeField', 'action'].includes(trigger.value)))
                            .map(trigger => {
                                return (
                                    <Select.Option key={trigger.value} value={trigger.value}>
                                        <LocaleText code={trigger.label} fallback={trigger.labelFallback}/>
                                    </Select.Option>
                                )
                            })}
                    </Select>
                </Form.Item>
                <Form.Item name={'closable'} label={<LocaleText code={'configuration.widget.popup.closable'} fallback={'Uzavíratelné'}/>} valuePropName={'checked'} initialValue={true}>
                    <Switch/>
                </Form.Item>
                <Collapse containerClassName={'mb-3'}
                          title={<LocaleText code={'configuration.widget.popup.confirm-button.options'}
                                             fallback={'Tlačítko "Potvrdit"'}/>}>
                    <Form.Item noStyle={true}>
                        <ButtonProperties namePath={['confirmButton']} defaultLabel={'Ok'} labelRequired={false}/>
                    </Form.Item>
                </Collapse>

                {options.trigger === 'button' && (
                    <Collapse containerClassName={'mb-3'}
                              title={<LocaleText code={'configuration.widget.popup.confirm-button.options'}
                                                 fallback={'Tlačítko spouště'}/>}>
                        <Form.Item noStyle={true}>
                            <ButtonProperties namePath={['triggerButton']} labelRequired={false}/>
                        </Form.Item>
                    </Collapse>
                )}
                {contentType && options.trigger === 'alertChangeField' && (
                    <Form.Item help={<LocaleText code={'configuration.widget.popup.alert-change-fields.help'}
                                                 fallback={'Zde se zobrazí pole, u kterého jste v nastavení polí zaškrtli „zahrnout pole do seznamu změn záznamu“.'}/>}
                               name={'alertChangeFields'}
                               label={<LocaleText code={'configuration.widget.popup.alert-change-fields'}
                                                  fallback={'Upozornění na změněná pole'}/>}>
                        <FieldPicker multiple={true} output={'name'} serviceClassName={contentType.fullClassName}
                                     includedInChangeList={true}/>
                    </Form.Item>
                )}
            </div>
        )
    }
}

export default PopupWidgetEditor